import { formValidation } from "./_vendor/@form-validation/esm/bundle/popular.min.js";
import { AutoFocus } from "./_vendor/@form-validation/esm/plugin-auto-focus";
import { Trigger } from "./_vendor/@form-validation/esm/plugin-trigger";

import {
    Messages,
    InvalidFieldEventHandler,
    ValidFieldEventHandler,
} from "./_form";

import { revalidateCalculatedBmi } from "./_formApplication";

const settings = {
    container: ".js-bmi-calc",
    clsHidden: "hidden",
};

let calcBtn;
let container;
let currentHeightUnit = "imperial";
let currentWeightUnit = "imperial";

let fieldCalculatedBmi;
let fieldHeightFt;
let fieldHeightIn;
let fieldHeightCm;
let fieldWeightSt;
let fieldWeightLbs;
let fieldWeightKg;

let fv;

const labelSwitchToImperialHeight = "Switch to ft, in";
const labelSwitchToImperialWeight = "Switch to st, lb";
const labelSwitchToMetricHeight = "Switch to cm";
const labelSwitchToMetricWeight = "Switch to kg";

const convertCmtoInches = (height) => {
    return Math.round(height * 0.3937);
};

const convertKilogramsToPounds = (weight) => {
    return Math.round(weight * 2.2046);
};

const convertFeetToInches = (height) => {
    return height * 12;
};

const convertStoneToPounds = (weight) => {
    return weight * 14;
};

const calculateBmi = (heightInInches, weightInStone) => {
    let bmi;
    bmi = (weightInStone / (heightInInches * heightInInches)) * 703;
    bmi = Math.round(bmi * 10) / 10;
    return bmi;
};

const renderBmi = (bmi) => {
    const result = container.querySelector("#bmi-result");
    result.innerHTML = `Your BMI is:<strong>${bmi}</strong>`;
};

const updateCalculatedBmiInput = (bmi) => {
    fieldCalculatedBmi.setAttribute("value", bmi);
};

const validateForm = () => {
    fv = formValidation(container, {
        fields: {
            height_ft: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    numeric: {
                        message: Messages.numeric,
                    },
                },
            },
            height_in: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    numeric: {
                        message: Messages.numeric,
                    },
                },
            },
            height_cm: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: Messages.default,
                    },
                    numeric: {
                        enabled: false,
                        message: Messages.numeric,
                    },
                },
            },
            weight_st: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    numeric: {
                        message: Messages.numeric,
                    },
                },
            },
            weight_lbs: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    numeric: {
                        message: Messages.numeric,
                    },
                },
            },
            weight_kg: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: Messages.default,
                    },
                    numeric: {
                        enabled: false,
                        message: Messages.numeric,
                    },
                },
            },
        },
        plugins: {
            autoFocus: new AutoFocus(),
            trigger: new Trigger(),
        },
    })
        .on("core.field.invalid", (fieldName) => {
            InvalidFieldEventHandler(fv, fieldName);
        })
        .on("core.field.valid", (fieldName) => {
            ValidFieldEventHandler(fv, fieldName);
        })
        .on("core.form.valid", () => {
            let heightInInches;
            if (currentHeightUnit === "imperial") {
                const heightFt = parseInt(fieldHeightFt.value, 10);
                const heightIn = parseInt(fieldHeightIn.value, 10);
                heightInInches = convertFeetToInches(heightFt) + heightIn;

                console.log(
                    `${currentHeightUnit}: ${heightFt}ft ${heightIn}in = ${heightInInches}in`,
                );
            } else {
                const heightCm = parseInt(fieldHeightCm.value, 10);
                heightInInches = convertCmtoInches(heightCm);

                console.log(
                    `${currentHeightUnit}: ${heightCm}cm = ${heightInInches}in`,
                );
            }

            let weightInPounds;
            if (currentWeightUnit === "imperial") {
                const weightSt = parseInt(fieldWeightSt.value, 10);
                const weightLbs = parseInt(fieldWeightLbs.value, 10);
                weightInPounds = convertStoneToPounds(weightSt) + weightLbs;

                console.log(
                    `${currentWeightUnit}: ${weightSt}st ${weightLbs}lbs = ${weightInPounds}lbs`,
                );
            } else {
                const weightKg = parseInt(fieldWeightKg.value, 10);
                weightInPounds = convertKilogramsToPounds(weightKg);

                console.log(
                    `${currentWeightUnit}: ${weightKg}kg = ${weightInPounds}lbs`,
                );
            }

            const bmi = calculateBmi(heightInInches, weightInPounds);
            renderBmi(bmi);
            updateCalculatedBmiInput(bmi);
            revalidateCalculatedBmi();
        });
};

const BmiCalculator = () => {
    container = document.querySelector(settings.container);
    if (container === null) {
        return;
    }

    // Bind the inputs.
    fieldCalculatedBmi = container.querySelector("#calculated_bmi");
    fieldHeightFt = container.querySelector("#height_ft");
    fieldHeightIn = container.querySelector("#height_in");
    fieldHeightCm = container.querySelector("#height_cm");

    fieldWeightSt = container.querySelector("#weight_st");
    fieldWeightLbs = container.querySelector("#weight_lbs");
    fieldWeightKg = container.querySelector("#weight_kg");

    // Bind the calculate button.
    calcBtn = container.querySelector("#calculate");

    // Create a FormValidation instance.
    validateForm();

    // Validate the form on click of the Calculate button.
    calcBtn.addEventListener("click", (event) => {
        event.preventDefault();
        fv.validate();
    });

    const switchWeightLink = container.querySelector("#switchWeight");
    const weightImperialSection = container.querySelector("#weightImperial");
    const weightMetricSection = container.querySelector("#weightMetric");

    switchWeightLink.addEventListener("click", (event) => {
        event.preventDefault();

        if (currentWeightUnit === "imperial") {
            // Switch to Metric.
            currentWeightUnit = "metric";

            // Show metric form fields.
            weightImperialSection.classList.add(settings.clsHidden);
            weightMetricSection.classList.remove(settings.clsHidden);

            // Enable metric field validation.
            fv.enableValidator("weight_kg");

            // Disable imperial field validation.
            fv.disableValidator("weight_st");
            fv.disableValidator("weight_lbs");

            // Update link title.
            event.currentTarget.innerHTML = labelSwitchToImperialWeight;
        } else {
            // Switch to Imperial.
            currentWeightUnit = "imperial";

            // Show imperial form fields.
            weightImperialSection.classList.remove(settings.clsHidden);
            weightMetricSection.classList.add(settings.clsHidden);

            // Disable metric field validation.
            fv.disableValidator("weight_kg");

            // Enable impoerial field validation.
            fv.enableValidator("weight_st");
            fv.enableValidator("weight_lbs");

            // Update link title.
            event.currentTarget.innerHTML = labelSwitchToMetricWeight;
        }
    });

    const switchHeightLink = container.querySelector("#switchHeight");
    const heightImperialSection = container.querySelector("#heightImperial");
    const heightMetricSection = container.querySelector("#heightMetric");

    switchHeightLink.addEventListener("click", (event) => {
        event.preventDefault();

        if (currentHeightUnit === "imperial") {
            // Switch to Metric.
            currentHeightUnit = "metric";

            // Show metric form fields.
            heightImperialSection.classList.add(settings.clsHidden);
            heightMetricSection.classList.remove(settings.clsHidden);

            // Enable metric field validation.
            fv.enableValidator("height_cm");

            // Disable imperial field validation.
            fv.disableValidator("height_ft");
            fv.disableValidator("height_in");

            // Update link title.
            event.currentTarget.innerHTML = labelSwitchToImperialHeight;
        } else {
            // Switch to Imperial.
            currentHeightUnit = "imperial";

            // Show imperial form fields.
            heightImperialSection.classList.remove(settings.clsHidden);
            heightMetricSection.classList.add(settings.clsHidden);

            // Disable metric field validation.
            fv.disableValidator("height_cm");

            // Enable imperial field validation.
            fv.enableValidator("height_ft");
            fv.enableValidator("height_in");

            // Update link title.
            event.currentTarget.innerHTML = labelSwitchToMetricHeight;
        }
    });
};

export default BmiCalculator;
